import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async"; // Corrected import for meta tags
import Nav from "../Navigation/NavBar";
import AboutContant from "./AboutContant";
import WhyChoose from "../Home/WhyChoose/WhyChoose";
import OurProcess from "..//Home/OurProcess/OurProcess";
import Company from "../AboutUs/Company";
import Footer from "../Footer/Footer";
import Directors from "./OurDirectors/Directors";
import Opration from "./OperationsHead/Oprations";

function About() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Helmet>
        <meta name="keywords" content="HR solutions, placement services, recruitment, Quarec Resources" />
        <meta name="author" content="Quarec Resources" />
      </Helmet>
      <Nav />
      <AboutContant />
      <WhyChoose />
      {/* <OurProcess /> */}
      <Directors />
      {/* <Opration /> */}
      <Company />
      <Footer />
    </>
  );
}

export default About;
